import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import solA from "./img/solution-tube-a-gel-modal.svg";
import solB from "./img/solution-tube-b-gel-modal.svg";
import solC from "./img/solution-tube-c-gel-modal.svg";
import solD from "./img/solution-tube-d-gel-modal.svg";
import solE from "./img/solution-tube-e-gel-modal.svg";
import solF from "./img/solution-tube-f-gel-modal.svg";
import gelImg from "./img/gel-lanes-6.svg";
import gelImgIdeal from "./img/gel-lanes-6-ideal.svg";

import "./style.scss";

const outerNameIndexMap = { A: 9, B: 10, C: 11, D: 12, E: 13, F: 14 };

const images = {
  solA: solA,
  solB: solB,
  solC: solC,
  solD: solD,
  solE: solE,
  solF: solF,
};

class GelResults extends Component {
  constructor(props) {
    super(props);
  }

  renderContentsList = (tube, source) => {
    //source = "ideal" if showing ideal data, not actual

    if (["A", "B", "C", "D", "E", "F"].includes(tube)) {
      //Choose between actual and ideal solution data
      let solutions = {};

      const idealSolutions = [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {
          type: "A",
          solutions: {
            "DNA Ladder": 1,
          },
        },
        {
          type: "B",
          solutions: {
            "CCR5 DNA": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "C",
          solutions: {
            "Control gRNA": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "D",
          solutions: {
            "gRNA-a": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "E",
          solutions: {
            "gRNA-b": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
        {
          type: "F",
          solutions: {
            "gRNA-c": 1,
            "CCR5 DNA": 1,
            "CAS9 Protein": 1,
            "10x DNA Cleavage Buffer": 1,
          },
        },
      ];

      if (source === "ideal") {
        solutions = idealSolutions[outerNameIndexMap[tube]].solutions;
      } else {
        solutions = this.props.solutions[outerNameIndexMap[tube]].solutions;
      }

      const solutionList = [];

      for (const i in solutions) {
        const colorStyle = this.getContentItemColorStyle(i);

        solutionList.push(
          <div className="results-tooltip-item">
            <div
              className="results-tooltip-item__text-color"
              style={{ backgroundColor: colorStyle }}
            ></div>
            <div className="results-tooltip-item__text">{i}</div>
          </div>
        );
      }

      return (
        <div
          className="tooltip-wrap"
          aria-label={
            solutionList.length > 0
              ? this.props.intl.formatMessage(
                  {
                    id: "Tube {tube} contains the following solutions:",
                    defaultMessage:
                      "Tube {tube} contains the following solutions:",
                    description: "",
                  },
                  {
                    tube: tube,
                  }
                )
              : this.props.intl.formatMessage(
                  {
                    id: "Tube {tube} is empty.",
                    defaultMessage: "Tube {tube} is empty.",
                    description: "",
                  },
                  {
                    tube: tube,
                  }
                )
          }
          style={{ padding: solutionList.length > 0 ? "1px 0px" : "8px 0px" }}
        >
          {solutionList.length > 0 ? solutionList : "Empty"}
        </div>
      );
    } else {
      return "";
    }
  };

  buildSolutionBlock = (tube, showCorrect, source, showLabels) => {
    //tube = A,B,C,D,E,F
    //showCorrect = true/false - displays the correct label below
    //source = "ideal" if showing ideal data, not actual

    function getCorrect() {
      if (showCorrect !== null) {
        if (showCorrect) {
          return (
            <div className="solution-card-footer__label correct">
              <FormattedMessage
                id="Correct"
                defaultMessage="Correct"
                description=""
              />
            </div>
          );
        } else {
          return (
            <div className="solution-card-footer__label incorrect">
              <FormattedMessage
                id="Incorrect"
                defaultMessage="Incorrect"
                description=""
              />
            </div>
          );
        }
      } else {
        return null;
      }
    }

    return (
      <div>
        {showLabels === true ? this.renderContentsList(tube, source) : null}
        <div className="solution-card-footer">
          <img
            className="solution-card-footer__image"
            src={images["sol" + tube]}
            alt={this.props.intl.formatMessage(
              {
                id: "Tube {tube}",
                defaultMessage: "Tube {tube}",
                description: "",
              },
              { tube: tube }
            )}
          />
          {getCorrect()}
        </div>
      </div>
    );
  };

  extractHeights = (tube, context) => {
    //return yA: {"DNA Ladder": 50, "CCR5":70}

    //TODO: Change to get from where calc'ed actual heights are stored
    const actualLaneHeights = {
      laneA: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
      laneB: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
      laneC: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
      laneD: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
      laneE: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
      laneF: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
        "CCR5 DNA": 69,
        "gRNA-a 1": 119,
        "gRNA-a 2": 200,
        "gRNA-b 1": 104,
        "gRNA-b 2": 170,
        "gRNA-c 1": 114,
        "gRNA-c 2": 210,
      },
    };

    const idealLaneHeights = {
      laneA: {
        "DNA Ladder 1": 42,
        "DNA Ladder 2": 104,
        "DNA Ladder 3": 133,
        "DNA Ladder 4": 162,
        "DNA Ladder 5": 200,
        "DNA Ladder 6": 224,
      },
      laneB: {
        "CCR5 DNA": 69,
      },
      laneC: {
        "CCR5 DNA": 69,
      },
      laneD: {
        //"CCR5 DNA": 69,
        "gRNA-a 1": 104,
        "gRNA-a 2": 191,
      },
      laneE: {
        //"CCR5 DNA": 69,
        "gRNA-b 1": 104,
        "gRNA-b 2": 191,
      },
      laneF: {
        //"CCR5 DNA": 69,
        "gRNA-c 1": 104,
        "gRNA-c 2": 191,
      },
    };

    // let actualLaneHeights = this.props.laneActual

    if (context === "predicted") {
      return this.props.lanePrediction["lane" + tube];
    } else if (context === "actual") {
      return actualLaneHeights["lane" + tube];
    } else if (context === "ideal") {
      return idealLaneHeights["lane" + tube];
    }
  };

  getBandAria = (band, offset) => {
    let aria = "";

    aria += band + " band.";

    if (offset < 42) {
      aria += " At the top of the gel.";
    } else {
      if (offset >= 42 && offset <= 77) {
        aria += " Uncut DNA position.";
      } else if (offset >= 104 && offset <= 171) {
        aria += " Fragment position 1.";
      } else if (offset > 198 && offset < 233) {
        aria += " Fragment position 2.";
      }
    }

    return aria;
  };

  renderBands = (tube, context) => {
    // predicted = true/false. False = actual

    let bandData = {
      yA: [],
      yB: [],
      yC: [],
      yD: [],
      yE: [],
      yF: [],
    };

    //Get predicted values set in modal
    bandData = {
      yA: this.extractHeights("A", context),
      yB: this.extractHeights("B", context),
      yC: this.extractHeights("C", context),
      yD: this.extractHeights("D", context),
      yE: this.extractHeights("E", context),
      yF: this.extractHeights("F", context),
    };

    const bandSolutions =
      context === "prediction"
        ? this.props.lanePrediction["lane" + tube]
        : this.props.laneActual["lane" + tube];
    const bandsOut = [];
    let i = 0;

    //should context = prediction or predicted ???

    if (context === "predicted" || context === "actual") {
      for (const sol in bandSolutions) {
        if (context === "predicted" && sol.includes("DNA Ladder")) {
          const reference = {
            "DNA Ladder 1": 42,
            "DNA Ladder 2": 104,
            "DNA Ladder 3": 133,
            "DNA Ladder 4": 162,
            "DNA Ladder 5": 200,
            "DNA Ladder 6": 224,
          };

          const bandIntensities = {
            "DNA Ladder 1": 3.33,
            "DNA Ladder 2": 3.33,
            "DNA Ladder 3": 3.33,
            "DNA Ladder 4": 3.33,
            "DNA Ladder 5": 3.33,
            "DNA Ladder 6": 3.33,
          };

          bandsOut.push(
            <div
              className="gel-band"
              id={"band_" + tube + "_" + sol}
              key={tube + (i + 1)}
              style={{
                width: "100%",
                height: bandIntensities[sol] + "px",
                position: "absolute",
                display:
                  bandData["y" + tube][sol] * 1.14 > 0 ? "block" : "none",
                transform:
                  "translate(0, " + (reference[sol] * 1.14 + 30) + "px)",
              }}
              aria-label=""
            ></div>
          );
        } else {
          // Additional conditions not currently required
          // DNA ladder < 5 -- no ladder
          // water < 10 -- upper band only

          const tubeRefs = {
            A: 9,
            B: 10,
            C: 11,
            D: 12,
            E: 13,
            F: 14,
          };

          const gRNAefficiencies = {
            "gRNA-a": 0.4,
            "gRNA-b": 0.3,
            "gRNA-c": 0.2,
          };

          const bandIntensities = {
            "DNA Ladder 1": 3.33,
            "DNA Ladder 2": 3.33,
            "DNA Ladder 3": 3.33,
            "DNA Ladder 4": 3.33,
            "DNA Ladder 5": 3.33,
            "DNA Ladder 6": 3.33,
            "CCR5 DNA": 20,
            "gRNA-a 1": 20,
            "gRNA-a 2": 20,
            "gRNA-b 1": 20,
            "gRNA-b 2": 20,
            "gRNA-c 1": 20,
            "gRNA-c 2": 20,
          };

          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "CCR5 DNA"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["CCR5 DNA"] !==
              null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["CCR5 DNA"]
            ) >= 1 &&
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "CAS9 Protein"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"] !==
              null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"]
            ) >= 1
          ) {
            if (
              Object.hasOwn(
                this.props.solutions[tubeRefs[tube]].solutions,
                "gRNA-a"
              ) &&
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-a"] !==
                null &&
              parseFloat(
                this.props.solutions[tubeRefs[tube]].solutions["gRNA-a"]
              ) >= 0.5
            ) {
              if (["gRNA-a 1", "gRNA-a 2", "CCR5 DNA"].includes(sol)) {
                bandIntensities[sol] = 20 * gRNAefficiencies["gRNA-a"];
                bandIntensities["CCR5 DNA"] =
                  20 - 40 * gRNAefficiencies["gRNA-a"];
              }
            }

            if (
              Object.hasOwn(
                this.props.solutions[tubeRefs[tube]].solutions,
                "gRNA-b"
              ) &&
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-b"] !==
                null &&
              parseFloat(
                this.props.solutions[tubeRefs[tube]].solutions["gRNA-b"]
              ) >= 0.5 &&
              Object.hasOwn(
                this.props.solutions[tubeRefs[tube]].solutions,
                "CAS9 Protein"
              ) &&
              this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"] !==
                null &&
              parseFloat(
                this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"]
              ) >= 1
            ) {
              if (["gRNA-b 1", "gRNA-b 2", "CCR5 DNA"].includes(sol)) {
                bandIntensities[sol] = 20 * gRNAefficiencies["gRNA-b"];
                bandIntensities["CCR5 DNA"] =
                  20 - 40 * gRNAefficiencies["gRNA-b"];
              }
            }

            if (
              Object.hasOwn(
                this.props.solutions[tubeRefs[tube]].solutions,
                "gRNA-c"
              ) &&
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-c"] !==
                null &&
              parseFloat(
                this.props.solutions[tubeRefs[tube]].solutions["gRNA-c"]
              ) >= 0.5 &&
              Object.hasOwn(
                this.props.solutions[tubeRefs[tube]].solutions,
                "CAS9 Protein"
              ) &&
              this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"] !==
                null &&
              parseFloat(
                this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"]
              ) >= 1
            ) {
              if (["gRNA-c 1", "gRNA-c 2", "CCR5 DNA"].includes(sol)) {
                bandIntensities[sol] = 20 * gRNAefficiencies["gRNA-c"];
                bandIntensities["CCR5 DNA"] =
                  20 - 40 * gRNAefficiencies["gRNA-c"];
              }
            }
          }

          // Result panel conditions:

          let gRNA1,
            gRNA2,
            gRNA3,
            enoughBuffer,
            enoughCCR5,
            enoughCas9 = false;

          // CCR5 < 1 -- no bands
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "CCR5 DNA"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["CCR5 DNA"] !==
              null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["CCR5 DNA"]
            ) >= 1
          ) {
            enoughCCR5 = true;
          }

          // 10x buffer < 1 -- upper band only
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "10x DNA Cleavage Buffer"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions[
              "10x DNA Cleavage Buffer"
            ] !== null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions[
                "10x DNA Cleavage Buffer"
              ]
            ) >= 1
          ) {
            enoughBuffer = true;
          }

          // Cas9 < 1 -- upper band only
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "CAS9 Protein"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"] !==
              null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["CAS9 Protein"]
            ) >= 1
          ) {
            enoughCas9 = true;
          }

          // gRNA < 0.5 -- upper band only
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "gRNA-a"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["gRNA-a"] !== null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-a"]
            ) >= 0.5
          ) {
            gRNA1 = true;
          }

          // gRNA < 0.5 -- upper band only
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "gRNA-b"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["gRNA-b"] !== null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-b"]
            ) >= 0.5
          ) {
            gRNA2 = true;
          }

          // gRNA < 0.5 -- upper band only
          if (
            Object.hasOwn(
              this.props.solutions[tubeRefs[tube]].solutions,
              "gRNA-c"
            ) &&
            this.props.solutions[tubeRefs[tube]].solutions["gRNA-c"] !== null &&
            parseFloat(
              this.props.solutions[tubeRefs[tube]].solutions["gRNA-c"]
            ) >= 0.5
          ) {
            gRNA3 = true;
          }

          if (
            context !== "actual" ||
            ([
              "DNA Ladder 1",
              "DNA Ladder 2",
              "DNA Ladder 3",
              "DNA Ladder 4",
              "DNA Ladder 5",
              "DNA Ladder 6",
            ].includes(sol) &&
              this.props.gelRun &&
              this.props.solutionsPipetted) ||
            (enoughCCR5 &&
              (![
                "gRNA-a 1",
                "gRNA-a 2",
                "gRNA-b 1",
                "gRNA-b 2",
                "gRNA-c 1",
                "gRNA-c 2",
              ].includes(sol) ||
                enoughCas9 & enoughBuffer) &&
              (!["gRNA-a 1", "gRNA-a 2"].includes(sol) || gRNA1) &&
              (!["gRNA-b 1", "gRNA-b 2"].includes(sol) || gRNA2) &&
              (!["gRNA-c 1", "gRNA-c 2"].includes(sol) || gRNA3) &&
              this.props.gelRun &&
              this.props.solutionsPipetted)
          ) {
            bandsOut.push(
              <div
                className="gel-band"
                id={"band_" + tube + "_" + sol}
                key={tube + (i + 1)}
                style={{
                  width: "100%",
                  height:
                    context === "actual"
                      ? bandIntensities[sol] + "px"
                      : 20 / Object.keys(bandData["y" + tube]).length + "px",
                  position: "absolute",
                  display:
                    bandData["y" + tube][sol] * 1.14 > 0 ? "block" : "none",
                  transform:
                    "translate(0, " +
                    (sol === "CCR5 DNA"
                      ? bandData["y" + tube][sol] * 1.14 +
                        (10 - bandIntensities[sol] / 2) +
                        30
                      : bandData["y" + tube][sol] * 1.14 + 30) +
                    "px)",
                }}
                aria-label={this.getBandAria(
                  sol,
                  sol === "CCR5 DNA"
                    ? bandData["y" + tube][sol] +
                        (10 - bandIntensities[sol] / 2)
                    : bandData["y" + tube][sol]
                )}
              ></div>
            );
          }
        }

        i++;
      }
    } else {
      for (const sol in bandData["y" + tube]) {
        bandsOut.push(
          <div
            className="gel-band"
            id={"band_" + tube + "_" + sol}
            key={tube + (i + 1)}
            style={{
              width: "100%",
              height: 20 / Object.keys(bandData["y" + tube]).length + "px",
              position: "absolute",
              display: bandData["y" + tube][sol] * 1.14 > 0 ? "block" : "none",
              transform:
                "translate(0, " +
                (bandData["y" + tube][sol] * 1.14 + 30) +
                "px)",
            }}
            aria-label={this.getBandAria(sol, bandData["y" + tube][sol])}
          ></div>
        );

        i++;
      }
    }

    return bandsOut;
  };

  buildGel = (context) => {
    return (
      <div className="gel-section-container">
        <div
          className="solution-card-container"
          style={{ width: "480px", marginLeft: "50px" }}
        >
          <div className="solution-card-container__result solution-1">
            {this.buildSolutionBlock(
              "A",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>

          <div className="solution-card-container__result solution-2">
            {this.buildSolutionBlock(
              "B",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>

          <div className="solution-card-container__result solution-3">
            {this.buildSolutionBlock(
              "C",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>

          <div className="solution-card-container__result solution-4">
            {this.buildSolutionBlock(
              "D",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>

          <div className="solution-card-container__result solution-5">
            {this.buildSolutionBlock(
              "E",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>

          <div className="solution-card-container__result solution-6">
            {this.buildSolutionBlock(
              "F",
              null,
              context === "ideal" ? "ideal" : null
            )}
          </div>
        </div>

        <div className="gel-img-container">
          <div className="gel-img-container__lane-wrap">
            <div className="gel-img-container__lane-wrap--lane lane-1">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("A", context)}
              </div>
            </div>

            <div className="gel-img-container__lane-wrap--lane lane-2">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("B", context)}
              </div>
            </div>

            <div className="gel-img-container__lane-wrap--lane lane-3">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("C", context)}
              </div>
            </div>

            <div className="gel-img-container__lane-wrap--lane lane-4">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("D", context)}
              </div>
            </div>

            <div className="gel-img-container__lane-wrap--lane lane-5">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("E", context)}
              </div>
            </div>

            <div className="gel-img-container__lane-wrap--lane lane-6">
              <div className="gel-rail" style={{ position: "relative" }}>
                {this.renderBands("F", context)}
              </div>
            </div>
          </div>

          <img
            className="gel-img"
            src={context === "actual" ? gelImg : gelImgIdeal}
            width="100%"
            alt={this.props.intl.formatMessage({
              id: "Gel",
              defaultMessage: "Gel",
              description: "",
            })}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="result-prediction">
        <h4
          className="sub-panel-heading"
          style={{ marginBottom: "10px", marginTop: "0" }}
        >
          <FormattedMessage
            id="Predicted results"
            defaultMessage="Predicted results"
            description=""
          />
        </h4>

        <div className="predicted-results-gel-container">
          {this.buildGel("predicted")}
        </div>

        <div className="rounded-text-box">
          <FormattedMessage
            id="You can compare your predictions to the actual results used in this experiment below."
            defaultMessage="You can compare your predictions to the actual results used in this experiment below."
            description=""
          />
        </div>

        <h4 className="sub-panel-heading" style={{ marginBottom: "10px" }}>
          <FormattedMessage
            id="Actual results"
            defaultMessage="Actual results"
            description=""
          />
        </h4>

        <div className="actual-results-gel-container">
          {this.buildGel("actual")}
        </div>

        <div className="rounded-text-box">
          <FormattedMessage
            id="You can compare your actual results with the ideal results, which would be produced if the protocol was correct, below."
            defaultMessage="You can compare your actual results with the ideal results, which would be produced if the protocol was correct, below."
            description=""
          />
        </div>

        <h4 className="sub-panel-heading" style={{ marginBottom: "10px" }}>
          <FormattedMessage
            id="Ideal results"
            defaultMessage="Ideal results"
            description=""
          />
        </h4>

        {this.buildGel("ideal")}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lanePrediction: state.gel.prediction,
    laneActual: state.gel.actual,
    solutions: state.solutions,
    //#TODO: Hook those with the protocol section steps reducer
    solutionsIncubated: true,
    solutionsPipetted: true,
    gelRun: true,
  };
};

const GelResultsWithIntl = injectIntl(GelResults);

export const AssayGelResults = connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <GelResultsWithIntl {...props} />
  </TranslationsProvider>
));
